<span *ngIf="value.split(':').length === 1">
  <i nz-icon [nzType]="value.split(':')[0]"></i>
</span>
<span *ngIf="value.split(':').length === 2">
  <i nz-icon [nzType]="value.split(':')[0]" nzTheme="twotone" [nzTwotoneColor]="value.split(':')[1]"></i>
</span>
<span *ngIf="value.split(':').length === 3">
  <i nz-icon [nzType]="value.split(':')[0]" nzTheme="twotone" [nzTwotoneColor]="value.split(':')[1]"></i>
  {{value.split(':')[2] | locale}}
</span>
